export default {
  modals: {
    delete_payment_method: {
      title: 'Weet je zeker dat je deze betaalmethode wilt verwijderen?',
    },
  },
  buttons: {
    confirm: 'Bevestigen',
    cancel: 'Annuleren',
  },
  toasts: {
    failed_to_delete_payment_method: 'Verwijderen van betaalmethode mislukt',
    payment_method_deleted: 'Betaalmethode verwijderd',
  },
};
